import { render } from "./AddHarvestComponent.vue?vue&type=template&id=98852864"
import script from "./AddHarvestComponent.vue?vue&type=script&lang=js"
export * from "./AddHarvestComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__